// extracted by mini-css-extract-plugin
export default {"header":"Header_header__8Zi33","left":"Header_left__lFX7H","middle":"Header_middle__pSSP+","right":"Header_right__a4i6X","buttons":"Header_buttons__l0pNy"};